/**
 * @desc 查询预告公告详情
 */
import { AnnouncementEntity } from '@eastcoal/api/trade/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryAnnouncementParameter = {
  id?: string
}

const method = 'GET'
const url = '/trade/operation/announcement'

export const queryAnnouncementApi = (
  params?: QueryAnnouncementParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<AnnouncementEntity>({
    method,
    url,
    params,
    ...config
  })
}

queryAnnouncementApi.method = method
queryAnnouncementApi.url = url
